// extracted by mini-css-extract-plugin
module.exports = {"playerRateModal":"xx","header":"xy","subHeader":"xz","rateOptionsRow":"xA","popover":"xB","popoverArrow":"xC","closeIcon":"xD","closeIconWrapper":"xE"};